module.exports = __webpack_public_path__ + "img/survey_header.ede25174.svg";